import { AuthImage } from "@/components/AuthImage";

const COLOR_MAP = {
  neutral: "#a1a1aa", beige: "#e8dcc4", cream: "#f5efe0", navy: "#1e2a4a",
  denim: "#3b5a80", khaki: "#b3a06b", tan: "#c9a87c", charcoal: "#333",
  white: "#f4f4f5", black: "#18181b", blue: "#2563eb", olive: "#556b2f",
  red: "#dc2626", green: "#16a34a", grey: "#6b7280", gray: "#6b7280", brown: "#6b4423",
};

export const cssColor = (name) => {
  if (!name) return "#3f3f46";
  return COLOR_MAP[name.toLowerCase()] || name.toLowerCase();
};

// Renders the real image for uploaded items, or a color-swatch placeholder for manual (no-image) items.
export const ItemThumb = ({ item, className, testId }) => {
  if (item.has_image) {
    return <AuthImage itemId={item.id} alt={item.name} className={className} testId={testId} />;
  }
  const c = cssColor(item.primary_color);
  return (
    <div
      className={`${className} flex flex-col items-center justify-center relative`}
      style={{ backgroundColor: c }}
      data-testid={testId}
    >
      <div className="absolute inset-0" style={{ backgroundColor: "rgba(0,0,0,0.35)" }} />
      <span className="relative font-mono-accent uppercase text-[0.6rem] tracking-[0.2em] text-white/70">{item.category}</span>
      <span className="relative font-display uppercase text-sm text-center px-2 leading-tight text-white mt-1 line-clamp-3">{item.name}</span>
    </div>
  );
};
